module.exports = __webpack_public_path__ + "img/send.1a77c0ef.svg";